import Auth from '../../../modules/Auth'
import Global from '../../../constants/Global.js'

export async function fetchFeed({ commit }) {
  await new Promise(resolve => {
    fetch(Global.getServerDomain() + `/feed`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      }
    })
      .then((res) => {
        return res.json()
      })
      .then((payload) => {
        commit('feed', payload);
        resolve();
      })
      .catch(error => console.error(error))
  })
}

// eslint-disable-next-line no-unused-vars
export function replyToGroupMember({ commit }, msg) {
  fetch(Global.getServerDomain() + `/messages/group/moderator/${msg._group.id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    },
    body: JSON.stringify({
      msg: msg.newMessage,
      receiver: msg._sUser.id
    })
  }).catch(error => console.error(error))
}

// eslint-disable-next-line no-unused-vars
export function replyToGroupMessage({ commit }, msg) {
  fetch(Global.getServerDomain() + `/messages/group/${msg.groupId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    },
    body: JSON.stringify({
      msg: msg.newMessage,
      isModerator: false
    })
  }).catch(error => console.error(error))
}

// eslint-disable-next-line no-unused-vars
export function replyToItemComment({ commit }, msg) {
  fetch(Global.getServerDomain() + `/messages/item/${msg.itemId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    },
    body: JSON.stringify({
      msg: msg.newMessage
    })
  }).catch(error => console.error(error))
}

// eslint-disable-next-line no-unused-vars
export function declineInvite({ commit }, invite) {
  fetch(Global.getServerDomain() + `/group/${invite.groupId}/declinejoininvitation`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    }
  })
    .catch(error => console.error(error))
}

// eslint-disable-next-line no-unused-vars
export function acceptModerationInvitation({ commit }, invite) {
  fetch(Global.getServerDomain() + `/group/${invite.groupId}/acceptmoderatorinvitation`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    }
  })
    .catch(error => console.error(error))
}

// eslint-disable-next-line no-unused-vars
export function declineModerationInvitation({ commit }, invite) {
  fetch(Global.getServerDomain() + `/group/${invite.groupId}/rejectmoderatorinvitation`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    }
  })
    .catch(error => console.error(error))
}

// eslint-disable-next-line no-unused-vars
export function replyToModerator({ commit }, msg) {
  fetch(Global.getServerDomain() + `/messages/group/member/${msg.group.id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    },
    body: JSON.stringify({
      msg: msg.newMessage
    })
  }).catch(error => console.error(error))
}

// eslint-disable-next-line no-unused-vars
export async function acceptRequestToJoin({ dispatch }, request) {
  return await new Promise(resolve => {
    fetch(Global.getServerDomain() + `/group/${request.groupId}/acceptjoinrequest`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      },
      body: JSON.stringify({
        user: request.sUserId
      })
    }).then(res => {
      let message = `Welcome to the ${request.group.name} group. Click <a onMouseOver="this.style.color='black'" onMouseOut="this.style.color='white'" style="color:white;text-decoration:underline !important;" href="${Global.getFrontDomain()}/s-app/group-page/${request.groupId}">here</a> to go to the group's home page.`;
      dispatch('sendSystemNotification', { partnerId: request.sUserId, msg: message, type: "JOIN_PUBLIC_GROUP" })
      resolve(res.json())
    })
      .catch(error => console.error(error))
  })

}

// eslint-disable-next-line no-unused-vars
export async function declineRequestToJoin({ dispatch }, request) {
  return await new Promise(resolve => {
    fetch(Global.getServerDomain() + `/group/${request.groupId}/remove`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      },
      body: JSON.stringify({
        user: request.sUserId
      })
    }).then(res => {
      resolve(res.json())
    })
      .catch(error => console.error(error))
  })
}

// eslint-disable-next-line no-unused-vars
export function replyToUser({ commit }, msg) {
  fetch(Global.getServerDomain() + `/messages/user/${msg.receiverId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    },
    body: JSON.stringify({
      msg: msg.newMessage
    })
  }).catch(error => console.error(error))
}

export function removeFromFeed({ commit }, { index }) {
  commit("remove_from_feed", { index: index });
}
